module.exports = __webpack_public_path__ + "static/template_options_multiweek-6e0627df1dd9004c403f88d89d2dc32b.png";